// Tags extension (API catalog store/extensions/tags): the words the product is found by — its type's own (the
// type and the groups above it, read-only; the type is the Type tab's) and the vendor's tags.
import { TagIcon } from "@heroicons/react/24/outline"
import TagsTab from "./TagsTab"
import { CatalogEditorProvider, catalogSection, catalogVisible, useCatalogVisibilityContext } from "../shared/catalog-editor"

export const StoreProductExtension = {
  id: "tags",
  label: "Tags",
  description: "The product type's tags and the vendor's own search tags",
  section: {
    component: catalogSection(TagsTab),
    label: "Tags",
    icon: TagIcon,
    order: 600,
    visible: catalogVisible("tags"),
  },
  provider: CatalogEditorProvider,
  visibilityContext: useCatalogVisibilityContext,
}
